import { ExperimentNames } from 'common/experiments/ExperimentDefinitions';
import { useExperiment } from 'src/shared/hooks/experiments/useExperiment';

/**
 * FAVORITES_V2 is fully rolled out (100% treatment). This reads the gate without
 * logging exposure — useExperiment defers by default and no caller fires it.
 */
export const useFavoritesV2Enabled = (): boolean => useExperiment(ExperimentNames.FAVORITES_V2).isTreatment;
